<template>
  <div id="examsList-page" class="template__content__align-between">
    <template v-if="exams.length">
      <div class="exams-list text-left">
        <div class="wrapper">
          <header class="exams-list__header">
            <h2 id="examslist-h2-name" class="h1 color--grey">
              <strong class="text-left">Olá, {{ userFirstName }} !</strong>
            </h2>
            <br />
            <p>Temos os seguintes serviços agendados com você.</p>
            <br />
          </header>

          <ul class="exams-list__list">
            <li class="exams-list__item" v-for="(exam, index) in exams" :key="index">
              <span id="examslist-span-schedulingdate" class="exams-list__item__date">
                {{ exam.schedulingDate | moment('DD/MM - HH:mm') }}
              </span>

              <div class="flex flex-justify-content--between">
                <p :id="`examslist-p-exam${exam.examCode}`" class="exams-list__item__exam-name">
                  {{
                    exam.examName
                      ? exam.examName.charAt(0).toUpperCase() + exam.examName.slice(1).toLowerCase()
                      : 'Exame não identificado'
                  }}
                </p>

                <p
                  v-show="exam.price !== 0"
                  :id="`examslist-p-examprice${exam.examCode}`"
                  class="exams-list__item__currency"
                >
                  R$ {{ exam.price | numberToCurrency }}
                </p>
              </div>

              <p class="exams-list__item__addimission-type">
                {{ admissionType }}
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div class="exams-continue-buttons flex flex-wrap flex-justify-content--center">
        <div v-show="!isThereSomeZeroValue" class="exams-total">
          <div>
            <strong>Valor Total:</strong>
          </div>

          <div id="examslist-currency-total">
            <strong>R$ {{ totalPrice | numberToCurrency }}</strong>
          </div>
        </div>

        <VButton id="examslist-btn-ok" text="Sim, está tudo certo" @click.native="nextStep()" />

        <VButton
          id="examslist-link-changeexams"
          text="Quero alterar meus serviços"
          variant="secondary"
          @click.native="changeExamsStep"
        />
      </div>
    </template>
    <template v-else>
      <header class="exams-list__header">
        <h2 id="examslist-h2-name" class="h1 color--grey">
          <strong>Olá, {{ userFirstName }} !</strong>
        </h2>
        <br />
        <p>Nenhum exame agendado</p>
      </header>

      <div>
        <div class="flex flex-wrap flex-justify-content--center">
          <VButton
            id="examslist-btn-conclusion"
            text="Concluir atendimento"
            @click.native="goNextStep('checkin_step')"
          ></VButton>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import VButton from '../components/commons/VButton.vue';
import { PaymentTypeClient } from '@/utils/enums/paymentMagicNumberEnum';
import { step } from '@/utils/enums/googleAnalytics';
import { getHoursDifferenceMixin, dataLayersMixin } from '@/utils/mixins';

export default {
  components: { VButton },
  name: 'ExamsList',

  mixins: [getHoursDifferenceMixin, dataLayersMixin],

  computed: {
    ...mapState({
      payment: ({ currentAdmission }) =>
        currentAdmission.data.payments &&
        currentAdmission.data.payments.length &&
        currentAdmission.data.payments[0],

      exams: ({ currentAdmission }) => currentAdmission.data.medicalOrders[0].exams,

      isElegibleProfessionalStep: ({ professionalIdentification }) =>
        professionalIdentification.isElegibleProfessionalStep,
    }),

    ...mapGetters({
      userFirstName: 'global/userFirstName',
      haveScheduledExams: 'haveScheduledExams',
      isT2FlowAllowed: 'global/isT2FlowAllowed',
      isVaccineFlow: 'global/isVaccineFlow',
      isMobileService: 'isMobileService',
      isOnlinePaymentEnabled: 'global/isOnlinePaymentEnabled',
    }),

    isThereSomeZeroValue() {
      return !!this.exams.find((exam) => exam.price === 0);
    },

    admissionType() {
      return this.payment?.clientId === PaymentTypeClient.PRIVATE ? 'Particular' : 'Convênio';
    },

    totalPrice() {
      return this.exams.reduce((p, c) => p + c.price, 0);
    },
  },

  totalPrice() {
    return this.exams.reduce((p, c) => p + c.price, 0);
  },
  created() {
    const examsList = [];

    this.exams.forEach((el) => {
      const model = {
        exame: el.examName,
        examCode: el.examCode,
      };
      examsList.push(model);
    });

    this.checkAndSetT2Flow();

    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Confira seus serviços',
    });
  },

  methods: {
    ...mapActions([
      'global/updateFlowSteps',
      'getDataProviderExamsCategories',
      'checkAndSetT2Flow',
    ]),

    changeExamsStep() {
      this.goNextStep('exams_service_desk');
    },

    async nextStep() {
      const EXAM_IMAGE_CATEGORY = 3;
      // eslint-disable-next-line
      dataLayer.push({
        ...step.EXAMS_COMPLETED,
        tipoAgendamento: this.haveScheduledExams.label,
      });

      this['global/updateFlowSteps']([2, 2]);

      if (this.isVaccineFlow) {
        const hoursDifference = this.returnHoursDifference(new Date(), this.examDate);
        if (hoursDifference <= 2) {
          return this.goNextStep('end_flow_success');
        }
        return this.goNextStep('queue_end_flow');
      }

      if (this.isT2FlowAllowed || this.isOnlinePaymentEnabled) {
        const examsCodes = this.exams.map((exam) => exam.examCode);

        const { data = [] } = await this.getDataProviderExamsCategories({ exams: examsCodes });
        const specialtiesExams = data.filter((ct) => ct.category?.id === EXAM_IMAGE_CATEGORY);
        if (specialtiesExams.length === this.exams.length) {
          return this.goNextStep('add_exams_check');
        }
      }

      if (this.isElegibleProfessionalStep) {
        return this.goNextStep('loading_medical_identity');
      }

      this.goNextStep('questions_step');
    },
  },
};
</script>

<style lang="scss" scoped>
#examsList-page {
  min-height: 90vh;
  height: calc(100vh - 110px);
}
.wrapper {
  display: flex;
  flex-direction: column;
}

.exams-list {
  flex-grow: 1;

  &__header {
    padding-top: 15px;
  }

  &__list {
    flex-grow: 0;
    overflow: auto;
    scroll-behavior: auto;
    height: 55vh;
  }

  &__item {
    padding: 0 0 27px 17px;
    position: relative;

    &::before {
      content: '';
      display: block;
      position: absolute;
      z-index: 2;
      left: -5px;
      top: -3px;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: var(--color-grey-5);
      border: 5px solid #f5f5f5;
    }

    &::after {
      $after: &;
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      left: 3px;
      top: 0;
      width: 3px;
      height: 100%;
      background-color: var(--color-grey-5);
    }

    &:last-child::after {
      display: none;
    }

    &__date {
      display: block;
      color: rgba(22, 22, 22, 0.64);
      font-size: var(--font-size-2);
      padding-bottom: 2px;
      font-weight: 700;
      line-height: 16.1px;
    }

    &__exam-name {
      color: #161616;
      padding-right: 10px;
      padding-bottom: 4px;
      font-size: var(--font-size-3);
      font-weight: 700;
      line-height: 24px;
    }

    &__currency {
      color: #161616;
      text-align: right;
      padding-bottom: 2px;
      min-width: 90px;
      font-size: var(--font-size-3);
      font-weight: 700;
      line-height: 24px;
    }

    &__addimission-type {
      display: block;
      color: var(--color-success);
      font-size: var(--font-size-1);
    }
  }
}

.exams-continue-buttons {
  background-color: white;
  padding: 20px 20px 30px;
  position: absolute;
  bottom: 0px;
  width: 100%;
  left: 0;
  z-index: 2;

  button:first-of-type {
    margin-bottom: 20px;
  }
}

.exams-total {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 20px 0;
}
</style>

<style lang="scss">
.exams-list {
  > .container {
    background-color: #f5f5f5;
  }
}
</style>
